import { useState, useContext, useEffect, useRef } from "react";
import Header from "../../Components/Header";
import ProgressBar from "../../Components/ProgressBar";
import "./step4.css";
import PortalContext from "../PortalContext";
import { useNavigate } from "react-router-dom";
import { sendGetRequest } from "../../Client";
import { useGetTranslation } from "../../Components/Translate";
import ServiceBlock from "./ServiceBlock";
import Mobile from "./Mobile";
import { Container, Row, Col } from "react-bootstrap";
import { sendPostRequest } from "../../Client/index.js";
import useIsMobile from "../../Hooks/useIsMobile";

export default function Step4() {
  const { portal } = useContext(PortalContext);
  const getTranslation = useGetTranslation();

  const voucherRefDesktop = useRef();
  const voucherRefMobile = useRef();

  const isMobile = useIsMobile(768);

  const navigate = useNavigate();

  useEffect(() => {
    if (!portal?.step2?.country) {
      // navigate(`/`, {
      //   replace: true,
      // });

      navigate(`/`);

      return;
    }
  }, []);

  const weight = portal?.step3?.weightQuestion
    ? portal?.step3?.weightQuestion
    : portal?.step3manual?.weightQuestion
    ? portal?.step3manual?.weightQuestion
    : "";

  const [reasons, setReasons] = useState("");

  const getReasons = async () => {
    // Read reasons from the normalized structure
    const items = portal?.step3?.items || portal?.step3manual?.items || [];

    const reasonsList = items
      .filter((i) => i?.selected)
      .map((i) => i?.reason)
      .filter(Boolean);

    return reasonsList.join("|");
  };

  useEffect(() => {
    const fetchReasons = async () => {
      const r = await getReasons();
      setReasons(r);
    };
    fetchReasons();
  }, [portal?.step3, portal?.step3manual]);

  const [servicesData, setServicesData] = useState([]);

  const fetchServices = async () => {
    try {
      const response = await sendGetRequest(
        `api/v2-label-portal-services.php` +
          `?country=${encodeURIComponent(portal?.step2?.country || "")}` +
          `&voucher=${encodeURIComponent(portal?.step1?.voucher || "")}` +
          `&weight=${encodeURIComponent(weight || "")}` +
          `&postcode=${encodeURIComponent(portal?.step2?.postcode || "")}` +
          `&reason=${encodeURIComponent(reasons || "")}`
      );
      setServicesData(response);
    } catch (err) {}
  };

  useEffect(() => {
    if (!reasons) return;
    fetchServices();
  }, [reasons]);

  const nonSelf = servicesData.filter((s) => s.serviceProvider !== 53);
  const selfPost = servicesData.filter((s) => s.serviceProvider === 53);

  let col1 = [];
  let col2 = [];
  let col3 = [];

  if (nonSelf.length >= 2) {
    nonSelf.forEach((item, idx) => (idx % 2 === 0 ? col1 : col2).push(item));
    col3 = selfPost;
  } else if (nonSelf.length === 1) {
    col1 = [nonSelf[0]];
    col2 = selfPost;
  } else {
    col1 = selfPost;
  }

  const { data, SKUs, step3, step3manual, ...removeData } = portal;

  const buildPayload = (service) => {
    // Prefer step3 if available, otherwise step3manual
    const unifiedStep3 = step3 ?? step3manual;

    // If we have a step3 object, filter out any items with quantity 0
    const cleanedStep3 = unifiedStep3
      ? {
          ...unifiedStep3,
          items: (unifiedStep3.items || []).filter(
            (item) => Number(item.quantity) > 0
          ),
        }
      : undefined;

    return {
      ...removeData,
      step3: cleanedStep3,
      step4: service,
    };
  };

  const handleSubmit = async (service) => {
    try {
      const payload = buildPayload(service);

      console.log("Submitting payload: STEP 4", payload);

      const res = await sendPostRequest(
        "api/v2-label-portal-create-order.php",
        payload
      );

      if (res?.status === "success" && res?.id) {
        navigate(`/order-success?s=${res.id}`, { replace: true });
      } else if (res?.status === "error" && res?.reason) {
        alert(res?.reason);
      } else if (res?.status === "stripe" && res?.url) {
        console.log("Redirecting to:", res.url);
        window.location.href = res.url;
      }
    } catch (err) {
      console.error("Error creating order:", err);
      alert("Unable to create your order right now. Please try again.");
    }
  };

  useEffect(() => {
    if (portal?.step1?.voucher) {
      fetchServices();
    }
  }, [portal?.step1?.voucher]);

  return (
    <>
      <Header />

      {isMobile ? (
        <section className="page3-slider py-lg-3">
          <div className="container">
            <ProgressBar step={4} />

            {portal?.data?.settings?.voucher?.visible &&
              (portal?.step1?.voucher ? (
                <div
                  style={{
                    backgroundColor: "#7eac7fff",
                    color: "#fff",
                    padding: "8px 16px",
                    borderRadius: 8,
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    margin: "0 auto 20px",
                    width: "80%",
                  }}
                >
                  <span style={{ fontSize: "1rem", marginRight: 6 }}>✓</span>
                  <span>
                    Voucher applied:{" "}
                    <strong style={{ color: "white", fontWeight: 600 }}>
                      {portal.step1.voucher}
                    </strong>
                  </span>
                </div>
              ) : (
                <form style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="text"
                    placeholder={getTranslation(
                      "STEP1_PLACEHOLDER_VOUCHER",
                      "Voucher code"
                    )}
                    name="voucher"
                    id="voucher"
                    style={{ width: 200, margin: "0 10px 10px 25px" }}
                    ref={voucherRefMobile}
                    defaultValue={portal?.step1?.voucher}
                  />
                  <button
                    type="button"
                    style={{
                      width: 100,
                      backgroundColor: portal.data.settings.colours.primary,
                    }}
                    className="btn btn-primary"
                    onClick={() => {
                      const voucher = voucherRefMobile.current?.value?.trim();
                      if (!voucher) return;
                      portal.step1 = { ...(portal.step1 || {}), voucher };
                      fetchServices();
                    }}
                  >
                    Apply
                  </button>
                </form>
              ))}

            {servicesData.map((service, index) => (
              <Mobile service={service} key={index} onSubmit={handleSubmit} />
            ))}
          </div>
        </section>
      ) : (
        <section className="page3-slider py-lg-3">
          <div className="container">
            <div className="row d-flex align-items-center">
              <div className="col-lg-12 col-12 pb-5">
                <ProgressBar step={4} />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 20,
                  }}
                >
                  <h2 style={{ margin: 0 }}>
                    {getTranslation("STEP4_TITLE", "Choose your service")}
                  </h2>

                  {portal?.data?.settings?.voucher?.visible &&
                    (portal?.step1?.voucher ? (
                      <div
                        style={{
                          marginLeft: 10,
                          backgroundColor: "#76c278ff",
                          color: "#fff",
                          padding: "8px 16px",
                          borderRadius: 8,
                          fontWeight: 500,
                          display: "flex",
                          alignItems: "center",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <span style={{ fontSize: "1rem", marginRight: 6 }}>
                          ✓
                        </span>
                        <span>
                          Voucher applied:{" "}
                          <strong style={{ color: "white", fontWeight: 600 }}>
                            {portal.step1.voucher}
                          </strong>
                        </span>
                      </div>
                    ) : (
                      <form style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="text"
                          placeholder={getTranslation(
                            "STEP1_PLACEHOLDER_VOUCHER",
                            "Voucher code (if applicable)"
                          )}
                          name="voucher"
                          id="voucher"
                          style={{ width: 220 }}
                          ref={voucherRefDesktop}
                          defaultValue={portal?.step1?.voucher}
                        />
                        <button
                          type="button"
                          style={{
                            width: 100,
                            marginLeft: 10,
                            backgroundColor:
                              portal.data.settings.colours.primary,
                          }}
                          className="btn btn-primary"
                          onClick={() => {
                            const voucher =
                              voucherRefDesktop.current?.value?.trim();
                            if (!voucher) return;
                            portal.step1 = { ...(portal.step1 || {}), voucher };
                            fetchServices();
                          }}
                        >
                          Apply
                        </button>
                      </form>
                    ))}
                </div>

                <Container fluid>
                  <Row>
                    <Col md={4}>
                      {col1.map((item, idx) => (
                        <ServiceBlock
                          key={item.id ?? idx}
                          data={item}
                          onSubmit={handleSubmit}
                        />
                      ))}
                    </Col>
                    <Col md={4}>
                      {col2.map((item, idx) => (
                        <ServiceBlock
                          key={item.id ?? idx}
                          data={item}
                          onSubmit={handleSubmit}
                        />
                      ))}
                    </Col>
                    <Col md={4}>
                      {col3.map((item, idx) => (
                        <ServiceBlock
                          key={item.id ?? idx}
                          data={item}
                          selfPost={true}
                          onSubmit={handleSubmit}
                        />
                      ))}
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
